import { MapPin } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { LOCATIONS } from "@/data/locations";

export const ServiceArea = () => {
    return (
        <div
            data-testid="service-area"
            aria-label="Service area"
            className="fixed inset-x-0 top-0 z-[60] border-b border-brand-border/60 bg-brand-bg"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 overflow-x-auto px-6 py-2 md:gap-6 md:px-10">
                <div className="inline-flex shrink-0 items-center gap-2">
                    <MapPin
                        size={14}
                        weight="duotone"
                        className="text-brand-accent"
                    />
                    <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-brand-accent">
                        Now serving
                    </span>
                </div>
                <ul className="flex shrink-0 items-center gap-x-4 md:gap-x-5">
                    {LOCATIONS.map((l, i) => (
                        <li
                            key={l.slug}
                            className="flex items-center gap-4 whitespace-nowrap"
                        >
                            <Link
                                to={`/service-areas/${l.slug}`}
                                data-testid={`service-city-${i}`}
                                className="text-xs font-semibold text-brand-text transition-colors hover:text-brand-accent"
                            >
                                {l.city}
                            </Link>
                            {i < LOCATIONS.length - 1 && (
                                <span
                                    aria-hidden
                                    className="h-1 w-1 rounded-full bg-brand-text/30"
                                />
                            )}
                        </li>
                    ))}
                    <li className="whitespace-nowrap text-xs font-medium text-brand-muted">
                        · Idaho
                    </li>
                </ul>
            </div>
        </div>
    );
};
